import { Typography } from '@/components/common';
import { Option } from '@/interfaces';
import Image from 'next/image';
import Link from 'next/link';
import * as React from 'react';

interface OurTeamProps {
	teamArray: Option[];
}

export const OurTeam: React.FC<OurTeamProps> = ({ teamArray }) => {
	return (
		<div className="flex flex-col items-center justify-center w-full h-full">
			<Link href={'https://lowey.com/'} target="_blank">
				<Image
					alt="lowey logo"
					src={'/img/landing/lowey-dannenberg-logo.png'}
					width={185}
					height={183}
					quality={100}
				/>
			</Link>
			<div className="flex flex-col items-center justify-center w-full mt-14">
				<Typography type="semibold-20" className="text-primary text-center">
					Our team represents you
				</Typography>
				<Typography
					type="regular-18"
					className="text-opacity-black mt-4 text-center"
				>
					Lowey Dannenberg has been delivering landmark results in complex cases
					for more than 50 years, having recovered billions of dollars for its
					clients in a wide range of cases, involving just about every kind of
					corporate misconduct.
				</Typography>
				<ul className="flex flex-wrap flex-col lg:flex-row gap-8 lg:gap-16 mt-11">
					{teamArray.map((person) => (
						<li key={person.name} className="m-4">
							<Image
								src={person.icon || ''}
								alt={person.name}
								width={198}
								height={201}
								className="rounded-full overflow-hidden"
							/>
							<Typography
								type="regular-18"
								className="text-grey-90 mt-2 text-center"
							>
								{person.name}
							</Typography>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};
